var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-100 h-100" },
    [
      _c(
        "v-card",
        {
          staticClass: "d-flex flex-column h-100",
          attrs: { elevation: "0", outlined: "", "min-height": "350" },
        },
        [
          _c(
            "v-card-title",
            { staticClass: "d-flex align-center" },
            [
              _c(
                "v-icon",
                {
                  staticClass: "mr-2",
                  attrs: { color: "secondary", large: "" },
                },
                [_vm._v("fireplace")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex flex-column flex-grow-1" }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "primary--text monospace-font body-1 font-weight-medium",
                  },
                  [_vm._v(_vm._s(_vm.$t("dashboards.hotPlayers")))]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "subheader-font body-2" }, [
                  _vm._v(_vm._s(_vm.$t(`dashboards.last_${_vm.period}`))),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "ml-2 elevation-0",
                  attrs: {
                    color: "secondary",
                    "x-small": "",
                    disabled: _vm.loading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onReloadClick()
                    },
                  },
                },
                [_c("v-icon", { attrs: { small: "" } }, [_vm._v("refresh")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider", {}),
          _vm._v(" "),
          _vm.data && _vm.data.length
            ? _c(
                "div",
                {
                  staticClass: "px-3 pt-1",
                  staticStyle: { "max-height": "71px" },
                },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      placeholder: _vm.$t("playerRecruitment.league"),
                      "item-text": "label",
                      "item-value": "id",
                      clearable: "",
                      items: _vm.filteredLeagues,
                      dense: "",
                      "hide-details": "",
                      outlined: "",
                    },
                    model: {
                      value: _vm.leagueModel,
                      callback: function ($$v) {
                        _vm.leagueModel = $$v
                      },
                      expression: "leagueModel",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.data && _vm.data.length
            ? _c(
                "div",
                {
                  staticClass: "px-3 py-1",
                  staticStyle: { "max-height": "71px" },
                },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      placeholder: _vm.$t("table.gameFlow.team"),
                      "item-text": "name",
                      "item-value": "id",
                      clearable: "",
                      items: _vm.filteredTeams,
                      dense: "",
                      "hide-details": "",
                      outlined: "",
                    },
                    model: {
                      value: _vm.teamModel,
                      callback: function ($$v) {
                        _vm.teamModel = $$v
                      },
                      expression: "teamModel",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("v-divider", { staticClass: "mb-1" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex align-center pl-5 pr-3 pb-1 body-2" },
            [
              _c("div", { staticClass: "w-65" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("playerDetail.name")))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "w-35 text-right" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("general.searches")))]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("v-divider", { staticClass: "mb-1" }),
          _vm._v(" "),
          _vm.orderedData && _vm.orderedData.length && !_vm.loading
            ? _c(
                "div",
                {
                  staticClass: "d-flex flex-column pl-5 pr-3 pb-1 flex-grow-1",
                  staticStyle: { overflow: "auto", "max-height": "240px" },
                },
                _vm._l(_vm.orderedData, function (d, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "element w-100 d-flex align-center mb-1",
                      staticStyle: { "min-height": "18px" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "w-80 d-flex align-center body-2" },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: {
                                top: "",
                                color: "lightSecondary lighten-4",
                                "max-width": "300",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            {
                                              staticClass: "mr-2",
                                              attrs: {
                                                "x-small": "",
                                                color: "secondary",
                                              },
                                            },
                                            on
                                          ),
                                          [_vm._v("info_outline")]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-column body-1 black--text font-weight-bold",
                                },
                                _vm._l(d.clients, function (c, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass:
                                        "d-flex justify-space-between align-center",
                                    },
                                    [
                                      _c("span", { staticClass: "mr-2" }, [
                                        _vm._v(_vm._s(c.clientName) + " "),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "font-weight-regular ml-2",
                                        },
                                        [_vm._v(_vm._s(c.searches))]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "w-100 d-flex" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass:
                                    "font-weight-medium mr-2 text-ellipsis",
                                  attrs: { to: `/player/${d.playerId}` },
                                },
                                [_vm._v(_vm._s(d.playerName))]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  staticClass:
                                    "text-ellipsis subheader-font primary--text",
                                  attrs: { to: `/team/${d.teamId}` },
                                },
                                [_vm._v("(" + _vm._s(d.teamName) + ")")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "w-20 text-right body-2" }, [
                        _c("span", [_vm._v(_vm._s(d.totalSearches))]),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          (!_vm.orderedData || !_vm.orderedData.length) && !_vm.loading
            ? _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-center align-center flex-column px-3 py-4 mb-7 text-center flex-grow-1",
                },
                [
                  _c(
                    "v-icon",
                    {
                      style: {
                        "font-size": _vm.$vuetify.breakpoint.mdAndUp
                          ? "80px"
                          : "60px",
                      },
                      attrs: { color: "primary lighten-5" },
                    },
                    [_vm._v("cloud_off")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "primary--text lighten--text-2 body-1" },
                    [_vm._v(_vm._s(_vm.$t("general.noData")))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.loading
            ? _c("v-skeleton-loader", {
                staticClass: "flex-grow-1",
                staticStyle: { overflow: "auto", "max-height": "240px" },
                attrs: { type: "list-item@10" },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }